module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信id:",
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "username", $$v)
      },
      expression: "loginForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60%",
      "font-weight": "bold"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "90%",
      "font-size": "15px"
    }
  }, [_vm._v("\n      备案/许可证编号为:蜀ICP备2020029625号-8\n    ")]), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "110%",
      "height": "1200px"
    },
    attrs: {
      "show-confirm-button": false,
      "title": ""
    },
    model: {
      value: (_vm.infoShow),
      callback: function($$v) {
        _vm.infoShow = $$v
      },
      expression: "infoShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "500px"
    }
  }, [(this.msg1) ? _c('van-loading', {
    attrs: {
      "type": "spinner",
      "size": "80px",
      "color": "#1989fa"
    }
  }) : _vm._e(), _vm._v(" "), (this.msg2) ? _c('van-loading', {
    attrs: {
      "type": "spinner",
      "size": "80px",
      "color": "#1989fa"
    }
  }, [_vm._v("后台管理员未审核请等待审核！ ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h2', [_vm._v("崃警网宣系统")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1480a40e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 527
// module chunks = 1